export enum Partners {
  OXFORD_IE = 'oxford-ie',
  PLAYSTRICT = 'playstrict',
  SEMRUSH = '22ab62a4-d8d8-47be-9d30-60db6492c109',
}
